import React, { useState, useRef, useEffect } from 'react';
import { ShoppingBag, User, Heart, Search, Menu, X, ArrowRight, ChevronRight, Star, Truck, Shield, RotateCcw, Plus, Grid3X3, Instagram, Leaf, Droplets, Recycle, Sun } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Template20 = () => {
    const navigate = useNavigate();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [hoveredProduct, setHoveredProduct] = useState(null);
    const [activeBrand, setActiveBrand] = useState('all');
    const [activeTestimonial, setActiveTestimonial] = useState(0);
    const [wishlist, setWishlist] = useState({});
    const touchStartX = useRef(0);

    // --- ORIGINAL data (desktop) ---
    const brands = [
        { id: 'all', name: 'All Brands' },
        { id: 'fabindia', name: 'FabIndia' },
        { id: 'biba', name: 'BIBA' },
        { id: 'wforwoman', name: 'W' },
    ];

    const featuredBrands = [
        { name: 'FabIndia', products: '1,200+', image: 'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=600&h=400&fit=crop' },
        { name: 'BIBA', products: '850+', image: 'https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?w=600&h=400&fit=crop' },
        { name: 'W for Woman', products: '720+', image: 'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=600&h=400&fit=crop' },
        { name: 'Manyavar', products: '640+', image: 'https://images.unsplash.com/photo-1594040226829-7f251ab46d80?w=600&h=400&fit=crop' },
        { name: 'Allen Solly', products: '980+', image: 'https://images.unsplash.com/photo-1558171813-4c088753af8f?w=600&h=400&fit=crop' },
        { name: 'Raymond', products: '560+', image: 'https://images.unsplash.com/photo-1594938298603-c8148c4dae35?w=600&h=400&fit=crop' },
    ];

    const desktopCategories = [
        { name: 'Women', count: '4,500+', image: 'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=500&h=700&fit=crop' },
        { name: 'Men', count: '3,200+', image: 'https://images.unsplash.com/photo-1558171813-4c088753af8f?w=500&h=700&fit=crop' },
        { name: 'Kids', count: '1,800+', image: 'https://images.unsplash.com/photo-1518831959646-742c3a14ebf7?w=500&h=700&fit=crop' },
    ];

    const desktopProducts = [
        { name: 'Block Print Kurta Set', brand: 'FabIndia', price: 3299, originalPrice: 4199, image: 'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=500&h=650&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?w=500&h=650&fit=crop', rating: 4.5, reviews: 234, tag: 'Bestseller' },
        { name: 'Printed Anarkali', brand: 'BIBA', price: 2899, originalPrice: 3699, image: 'https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?w=500&h=650&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=500&h=650&fit=crop', rating: 4.7, reviews: 189, tag: null },
        { name: 'Fusion Tunic', brand: 'W', price: 1999, originalPrice: 2599, image: 'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=500&h=650&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1496747611176-843222e1e57c?w=500&h=650&fit=crop', rating: 4.4, reviews: 312, tag: 'New' },
        { name: 'Cotton Palazzo Set', brand: 'FabIndia', price: 2599, originalPrice: 3299, image: 'https://images.unsplash.com/photo-1496747611176-843222e1e57c?w=500&h=650&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=500&h=650&fit=crop', rating: 4.6, reviews: 156, tag: null },
        { name: 'Embroidered Kurta', brand: 'BIBA', price: 2199, originalPrice: 2799, image: 'https://images.unsplash.com/photo-1564257631407-4deb1f99d992?w=500&h=650&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1558171813-4c088753af8f?w=500&h=650&fit=crop', rating: 4.5, reviews: 278, tag: 'Sale' },
        { name: 'Linen Shirt Dress', brand: 'W', price: 2499, originalPrice: 3199, image: 'https://images.unsplash.com/photo-1558171813-4c088753af8f?w=500&h=650&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1564257631407-4deb1f99d992?w=500&h=650&fit=crop', rating: 4.3, reviews: 198, tag: null },
        { name: 'Chanderi Dupatta Set', brand: 'FabIndia', price: 4499, originalPrice: 5699, image: 'https://images.unsplash.com/photo-1594040226829-7f251ab46d80?w=500&h=650&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1595950653106-6c9ebd614d3a?w=500&h=650&fit=crop', rating: 4.8, reviews: 423, tag: 'Premium' },
        { name: 'Asymmetric Kurti', brand: 'W', price: 1799, originalPrice: 2299, image: 'https://images.unsplash.com/photo-1595950653106-6c9ebd614d3a?w=500&h=650&fit=crop', hoverImage: 'https://images.unsplash.com/photo-1594040226829-7f251ab46d80?w=500&h=650&fit=crop', rating: 4.2, reviews: 167, tag: 'New' },
    ];

    const desktopServices = [
        { icon: Truck, title: 'Free Shipping', desc: 'On orders above ₹999' },
        { icon: Shield, title: '100% Authentic', desc: 'Genuine products only' },
        { icon: RotateCcw, title: 'Easy Returns', desc: '15-day return policy' },
    ];

    const desktopReviews = [
        { text: 'Amazing collection of brands under one roof. The quality and authenticity is guaranteed. Love shopping here!', name: 'Sneha Kapoor', city: 'Mumbai', rating: 5 },
        { text: 'Found my entire wedding wardrobe here. Great discounts and genuine products from all my favorite brands.', name: 'Priya Sharma', city: 'Delhi', rating: 5 },
        { text: 'Super fast delivery and excellent packaging. Customer service is very responsive. Highly recommend!', name: 'Kavitha Reddy', city: 'Bangalore', rating: 5 },
    ];

    // --- CURRENT data (mobile) ---
    const mobileCategories = [
        { name: 'Organic Cotton', image: 'https://images.unsplash.com/photo-1523381210434-271e8be1f52b?w=600&h=800&fit=crop', tagline: 'Gentle on Earth' },
        { name: 'Linen Collection', image: 'https://images.unsplash.com/photo-1594938298603-c8148c4dae35?w=600&h=800&fit=crop', tagline: 'Breathe naturally' },
        { name: 'Hemp Essentials', image: 'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=600&h=800&fit=crop', tagline: 'Zero waste fiber' },
        { name: 'Bamboo Basics', image: 'https://images.unsplash.com/photo-1469334031218-e382a71b716b?w=600&h=800&fit=crop', tagline: 'Soft & sustainable' },
    ];

    const mobileProducts = [
        { name: 'Organic Cotton Wrap Dress', price: 3800, image: 'https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=500&h=650&fit=crop', tag: 'Eco Choice', color: 'Oatmeal' },
        { name: 'Linen Wide-Leg Trousers', price: 4200, image: 'https://images.unsplash.com/photo-1584917865442-de89df76afd3?w=500&h=650&fit=crop', tag: null, color: 'Sage' },
        { name: 'Hemp Blend Tunic', price: 3200, image: 'https://images.unsplash.com/photo-1543163521-1bf539c55dd2?w=500&h=650&fit=crop', tag: 'New', color: 'Terracotta' },
        { name: 'Bamboo Lounge Set', price: 4800, image: 'https://images.unsplash.com/photo-1564257631407-4deb1f99d992?w=500&h=650&fit=crop', tag: null, color: 'Cloud' },
        { name: 'Recycled Denim Jacket', price: 5600, image: 'https://images.unsplash.com/photo-1591047139829-d91aecb6caea?w=500&h=650&fit=crop', tag: 'Upcycled', color: 'Stone Wash' },
        { name: 'Natural Dye Kurta', price: 2900, image: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=500&h=650&fit=crop', tag: null, color: 'Indigo' },
    ];

    const mobileTestimonials = [
        { text: 'I can feel the difference in every thread. Knowing that my clothes are kind to the planet makes me love them even more. The organic cotton dress is heavenly soft.', name: 'Priya Sharma', city: 'Pondicherry', rating: 5 },
        { text: 'Bloom is the only brand I trust for sustainable fashion. The linen trousers fit beautifully and they just get softer with every wash. Truly conscious luxury.', name: 'Arundhati Sen', city: 'Kolkata', rating: 5 },
        { text: 'Finally found fashion that aligns with my values without sacrificing style. The natural dyes create the most beautiful, unique shades. Each piece tells a story.', name: 'Maya Krishnan', city: 'Coorg', rating: 5 },
    ];

    const mobileFeatures = [
        { icon: Leaf, title: '100% Organic', desc: 'Certified natural fabrics' },
        { icon: Droplets, title: 'Low Water', desc: '70% less water used' },
        { icon: Recycle, title: 'Zero Waste', desc: 'Closed-loop production' },
        { icon: Sun, title: 'Carbon Neutral', desc: 'Offset every shipment' },
    ];

    const instagramPosts = [
        'https://images.unsplash.com/photo-1523381210434-271e8be1f52b?w=400&h=400&fit=crop',
        'https://images.unsplash.com/photo-1594938298603-c8148c4dae35?w=400&h=400&fit=crop',
        'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=400&h=400&fit=crop',
        'https://images.unsplash.com/photo-1469334031218-e382a71b716b?w=400&h=400&fit=crop',
        'https://images.unsplash.com/photo-1529139574466-a303027c1d8b?w=400&h=400&fit=crop',
        'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400&h=400&fit=crop',
    ];

    useEffect(() => {
        const timer = setInterval(() => {
            setActiveTestimonial(prev => (prev + 1) % mobileTestimonials.length);
        }, 5000);
        return () => clearInterval(timer);
    }, [mobileTestimonials.length]);

    const handleTestimonialSwipe = (e, type) => {
        if (type === 'start') touchStartX.current = e.touches[0].clientX;
        if (type === 'end') {
            const diff = touchStartX.current - e.changedTouches[0].clientX;
            if (Math.abs(diff) > 50) {
                setActiveTestimonial(prev => diff > 0 ? (prev + 1) % mobileTestimonials.length : (prev - 1 + mobileTestimonials.length) % mobileTestimonials.length);
            }
        }
    };

    return (
        <div className="w-full min-h-screen bg-white font-sans">
            {/* ==================== TOP BAR ==================== */}
            {/* Mobile Top Bar */}
            <div className="lg:hidden bg-emerald-800 text-emerald-100 text-center py-2 text-[10px] sm:text-xs tracking-[0.2em] px-4">
                PLASTIC-FREE PACKAGING | CARBON-NEUTRAL SHIPPING ON ALL ORDERS
            </div>
            {/* Desktop Top Bar - EXACT original */}
            <div className="hidden lg:block bg-slate-900 text-white text-center py-2 text-xs tracking-wide">
                FREE SHIPPING ON ORDERS OVER ₹999 | 50+ PREMIUM BRANDS
            </div>

            {/* ==================== HEADER ==================== */}
            {/* Mobile Header */}
            <header className="lg:hidden bg-stone-50/90 backdrop-blur-md sticky top-0 z-50 border-b border-stone-200">
                <div className="max-w-screen-2xl mx-auto">
                    <div className="flex items-center justify-between px-4 sm:px-6 py-3 sm:py-4">
                        <button className="min-w-[44px] min-h-[44px] flex items-center justify-center" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
                            {mobileMenuOpen ? <X className="w-5 h-5 text-stone-800" /> : <Menu className="w-5 h-5 text-stone-800" />}
                        </button>
                        <h1 onClick={() => navigate('/template20')} className="text-xl sm:text-2xl font-light tracking-[0.2em] text-stone-800 cursor-pointer">
                            BLOOM
                        </h1>
                        <div className="flex items-center gap-3 sm:gap-5">
                            <button className="min-w-[44px] min-h-[44px] flex items-center justify-center"><Search className="w-5 h-5 text-stone-600 hover:text-emerald-700 transition-colors" /></button>
                            <button className="min-w-[44px] min-h-[44px] hidden sm:flex items-center justify-center" onClick={() => navigate('/template20/profile')}><User className="w-5 h-5 text-stone-600 hover:text-emerald-700 transition-colors" /></button>
                            <button className="relative min-w-[44px] min-h-[44px] flex items-center justify-center" onClick={() => navigate('/template20/cart')}>
                                <ShoppingBag className="w-5 h-5 text-stone-600 hover:text-emerald-700 transition-colors" />
                                <span className="absolute top-1 right-0.5 w-4 h-4 bg-emerald-700 text-white text-[10px] rounded-full flex items-center justify-center">0</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div className={`bg-stone-50 border-t border-stone-200 overflow-hidden transition-all duration-300 ${mobileMenuOpen ? 'max-h-[400px] opacity-100' : 'max-h-0 opacity-0'}`}>
                    <nav className="px-5 py-6 space-y-1">
                        <button onClick={() => { navigate('/template20/shop'); setMobileMenuOpen(false); }} className="block w-full text-left py-3 text-base text-stone-800 border-b border-stone-100 tracking-wide">Shop</button>
                        <button onClick={() => setMobileMenuOpen(false)} className="block w-full text-left py-3 text-base text-stone-800 border-b border-stone-100 tracking-wide">Our Story</button>
                        <button onClick={() => setMobileMenuOpen(false)} className="block w-full text-left py-3 text-base text-stone-800 border-b border-stone-100 tracking-wide">Sustainability</button>
                        <button onClick={() => { navigate('/template20/contact'); setMobileMenuOpen(false); }} className="block w-full text-left py-3 text-base text-stone-800 border-b border-stone-100 tracking-wide">Contact</button>
                        <div className="flex gap-4 pt-4">
                            <button onClick={() => { navigate('/template20/profile'); setMobileMenuOpen(false); }} className="flex items-center gap-2 text-sm text-stone-500"><User className="w-4 h-4" /> Account</button>
                            <button className="flex items-center gap-2 text-sm text-stone-500"><Heart className="w-4 h-4" /> Wishlist</button>
                        </div>
                    </nav>
                </div>
            </header>

            {/* Desktop Header - EXACT original */}
            <header className="hidden lg:block bg-white sticky top-0 z-50 border-b border-slate-200">
                <div className="max-w-screen-2xl mx-auto">
                    <div className="flex items-center justify-between px-4 lg:px-8 py-4">
                        {/* Logo */}
                        <h1 onClick={() => navigate('/template20')} className="text-2xl lg:text-3xl font-black tracking-tight text-slate-900 cursor-pointer">
                            SUPREME
                        </h1>

                        {/* Desktop Nav */}
                        <nav className="flex items-center gap-8">
                            <button onClick={() => navigate('/template20/shop')} className="text-sm font-medium text-slate-700 hover:text-slate-900 transition-colors">
                                Shop All
                            </button>
                            <button className="text-sm font-medium text-slate-700 hover:text-slate-900 transition-colors">
                                Brands
                            </button>
                            <button className="text-sm font-medium text-slate-700 hover:text-slate-900 transition-colors">
                                Women
                            </button>
                            <button className="text-sm font-medium text-slate-700 hover:text-slate-900 transition-colors">
                                Men
                            </button>
                            <button className="text-sm font-medium text-red-600 hover:text-red-700 transition-colors">
                                Sale
                            </button>
                        </nav>

                        {/* Search & Icons */}
                        <div className="flex items-center gap-4">
                            <div className="flex items-center bg-slate-100 rounded-lg px-4 py-2">
                                <Search className="w-4 h-4 text-slate-400" />
                                <input type="text" placeholder="Search brands, products..." className="bg-transparent border-0 text-sm ml-2 focus:outline-none w-48" />
                            </div>
                            <User className="w-5 h-5 text-slate-700 cursor-pointer hover:text-slate-900 transition-colors" onClick={() => navigate('/template20/profile')} />
                            <Heart className="w-5 h-5 text-slate-700 cursor-pointer hover:text-slate-900 transition-colors" />
                            <div className="relative cursor-pointer" onClick={() => navigate('/template20/cart')}>
                                <ShoppingBag className="w-5 h-5 text-slate-700 hover:text-slate-900 transition-colors" />
                                <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-600 text-white text-[10px] rounded-full flex items-center justify-center font-bold">0</span>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            {/* ==================== HERO ==================== */}
            {/* Mobile Hero - current stacked design */}
            <section className="lg:hidden">
                <div className="relative aspect-[4/5]">
                    <img src="https://images.unsplash.com/photo-1523381210434-271e8be1f52b?w=1920&q=80" alt="Sustainable Fashion" className="w-full h-full object-cover" />
                </div>
                <div className="bg-emerald-50 px-5 py-8 text-center">
                    <p className="text-emerald-600 text-[10px] tracking-[0.3em] mb-2">SPRING/SUMMER 2025</p>
                    <h2 className="text-2xl sm:text-3xl font-light text-stone-900 mb-3 leading-tight tracking-wide">Fashion That<br />Nurtures the Earth</h2>
                    <p className="text-[14px] text-stone-500 mb-6 max-w-sm mx-auto leading-relaxed">Organic, natural, and crafted with care. Every piece is a promise to the planet and to you.</p>
                    <button onClick={() => navigate('/template20/shop')} className="w-full py-4 bg-emerald-700 text-white text-sm tracking-[0.2em] hover:bg-emerald-600 transition-colors min-h-[48px] rounded-full">
                        SHOP SUSTAINABLY
                    </button>
                </div>
            </section>

            {/* Desktop Hero - EXACT original */}
            <section className="hidden lg:block relative h-[85vh] bg-slate-900">
                <img
                    src="https://images.unsplash.com/photo-1558171813-4c088753af8f?w=1920&h=1080&fit=crop"
                    alt="Hero"
                    className="w-full h-full object-cover opacity-50"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-slate-900 via-slate-900/80 to-transparent"></div>

                <div className="absolute inset-0 flex items-center">
                    <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 w-full">
                        <div className="max-w-2xl">
                            <p className="text-slate-400 text-sm tracking-[0.3em] mb-4">50+ PREMIUM BRANDS</p>
                            <h1 className="text-5xl lg:text-7xl font-black text-white mb-6 leading-[0.95]">
                                YOUR STYLE,<br />
                                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400">ONE DESTINATION</span>
                            </h1>
                            <p className="text-slate-300 text-lg mb-8 max-w-lg">
                                Shop authentic products from FabIndia, BIBA, W, Manyavar, and 50+ more premium brands. All in one place.
                            </p>
                            <div className="flex flex-wrap gap-4">
                                <button
                                    onClick={() => navigate('/template20/shop')}
                                    className="group px-8 py-4 bg-white text-slate-900 font-bold tracking-wide hover:bg-slate-100 transition-colors inline-flex items-center gap-2"
                                >
                                    SHOP NOW <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                                </button>
                                <button className="px-8 py-4 border border-white/30 text-white font-medium tracking-wide hover:bg-white/10 transition-colors">
                                    EXPLORE BRANDS
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ==================== FEATURES / SERVICES ==================== */}
            {/* Mobile Features - horizontal scroll */}
            <section className="lg:hidden py-6 sm:py-8 bg-emerald-50 border-b border-emerald-100">
                <div className="max-w-screen-2xl mx-auto">
                    <div className="flex overflow-x-auto gap-4 px-5 snap-x snap-mandatory scrollbar-hide" style={{ WebkitOverflowScrolling: 'touch' }}>
                        {mobileFeatures.map((f, idx) => (
                            <div key={idx} className="w-[60vw] flex-shrink-0 snap-center flex items-center gap-3 p-4">
                                <f.icon className="w-6 h-6 text-emerald-600 flex-shrink-0" strokeWidth={1.5} />
                                <div>
                                    <h3 className="text-sm font-medium text-stone-800">{f.title}</h3>
                                    <p className="text-[13px] text-stone-500">{f.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Desktop Services Bar - EXACT original */}
            <section className="hidden lg:block bg-slate-50 py-4 border-b border-slate-200">
                <div className="max-w-screen-2xl mx-auto px-4 lg:px-8">
                    <div className="flex flex-wrap justify-center items-center gap-8 lg:gap-16">
                        {desktopServices.map((service, idx) => (
                            <div key={idx} className="flex items-center gap-3">
                                <service.icon className="w-5 h-5 text-slate-700" />
                                <div>
                                    <span className="font-semibold text-slate-800 text-sm">{service.title}</span>
                                    <span className="text-slate-500 text-sm ml-2">{service.desc}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ==================== CATEGORIES ==================== */}
            {/* Mobile Categories - horizontal scroll */}
            <section className="lg:hidden py-10 sm:py-16">
                <div className="max-w-screen-2xl mx-auto">
                    <div className="px-5 sm:px-6 mb-6 text-center">
                        <p className="text-emerald-600 text-[10px] sm:text-xs tracking-[0.3em] mb-1">SUSTAINABLE FIBERS</p>
                        <h2 className="text-xl sm:text-2xl font-light text-stone-900 tracking-wide">Shop by Material</h2>
                    </div>
                    <div className="flex overflow-x-auto gap-3 px-5 snap-x snap-mandatory scrollbar-hide" style={{ WebkitOverflowScrolling: 'touch' }}>
                        {mobileCategories.map((cat, idx) => (
                            <div key={idx} className="w-[68vw] flex-shrink-0 snap-center group cursor-pointer">
                                <div className="relative aspect-[3/4] overflow-hidden rounded-2xl">
                                    <img src={cat.image} alt={cat.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                                    <div className="absolute inset-0 bg-gradient-to-t from-stone-900/60 via-transparent to-transparent" />
                                    <div className="absolute bottom-0 left-0 right-0 p-5">
                                        <p className="text-emerald-300 text-[10px] tracking-[0.2em] mb-1">{cat.tagline.toUpperCase()}</p>
                                        <h3 className="text-lg font-light text-white tracking-wide">{cat.name}</h3>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="px-5 mt-2">
                        <div className="w-16 h-0.5 bg-stone-200 rounded-full mx-auto"><div className="w-6 h-full bg-emerald-500 rounded-full" /></div>
                    </div>
                </div>
            </section>

            {/* Desktop Shop by Category - EXACT original */}
            <section className="hidden lg:block py-24">
                <div className="max-w-screen-2xl mx-auto px-4 lg:px-8">
                    <div className="flex items-end justify-between mb-10">
                        <div>
                            <p className="text-slate-500 text-sm tracking-wider mb-2">SHOP BY</p>
                            <h2 className="text-4xl font-black text-slate-900">Category</h2>
                        </div>
                    </div>

                    <div className="grid grid-cols-3 gap-6">
                        {desktopCategories.map((cat, idx) => (
                            <div key={idx} className="group cursor-pointer relative overflow-hidden">
                                <div className="aspect-[4/5] overflow-hidden">
                                    <img
                                        src={cat.image}
                                        alt={cat.name}
                                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                                    />
                                </div>
                                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 via-slate-900/30 to-transparent"></div>
                                <div className="absolute bottom-0 left-0 right-0 p-6">
                                    <h3 className="text-3xl font-black text-white mb-1">{cat.name}</h3>
                                    <p className="text-slate-300 text-sm">{cat.count} products</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ==================== FEATURED BRANDS (desktop only) ==================== */}
            <section className="hidden lg:block py-24 bg-slate-50">
                <div className="max-w-screen-2xl mx-auto px-4 lg:px-8">
                    <div className="flex items-end justify-between mb-10">
                        <div>
                            <p className="text-slate-500 text-sm tracking-wider mb-2">SHOP FROM</p>
                            <h2 className="text-4xl font-black text-slate-900">Premium Brands</h2>
                        </div>
                        <button className="flex items-center gap-2 text-sm font-medium text-slate-700 hover:text-slate-900 transition-colors">
                            View All <ChevronRight className="w-4 h-4" />
                        </button>
                    </div>

                    <div className="grid grid-cols-6 gap-4">
                        {featuredBrands.map((brand, idx) => (
                            <div key={idx} className="group cursor-pointer bg-white overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300">
                                <div className="aspect-[3/2] overflow-hidden">
                                    <img
                                        src={brand.image}
                                        alt={brand.name}
                                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                    />
                                </div>
                                <div className="p-3 text-center">
                                    <h3 className="font-bold text-slate-800 text-sm">{brand.name}</h3>
                                    <p className="text-xs text-slate-500">{brand.products} products</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ==================== PRODUCTS ==================== */}
            {/* Mobile Products - horizontal scroll with wishlist/quick-add */}
            <section className="lg:hidden py-10 sm:py-16 bg-stone-100/50">
                <div className="max-w-screen-2xl mx-auto">
                    <div className="flex items-end justify-between px-5 sm:px-6 mb-6 sm:mb-10">
                        <div>
                            <p className="text-emerald-600 text-[10px] sm:text-xs tracking-[0.3em] mb-1">CONSCIOUS PICKS</p>
                            <h2 className="text-xl sm:text-2xl font-light text-stone-900 tracking-wide">New Arrivals</h2>
                        </div>
                    </div>
                    <div className="flex overflow-x-auto gap-3 px-5 snap-x snap-mandatory scrollbar-hide" style={{ WebkitOverflowScrolling: 'touch' }}>
                        {mobileProducts.map((product, idx) => (
                            <div key={idx} className="w-[44vw] flex-shrink-0 snap-start group">
                                <div className="relative aspect-[3/4] overflow-hidden rounded-xl mb-2 sm:mb-3 bg-stone-100">
                                    <img src={product.image} alt={product.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                                    {product.tag && <span className="absolute top-2 left-2 bg-emerald-700 text-white text-[9px] sm:text-[10px] tracking-wider px-2 py-1 rounded-full">{product.tag}</span>}
                                    <button onClick={() => setWishlist(prev => ({ ...prev, [idx]: !prev[idx] }))} className="absolute top-2 right-2 w-8 h-8 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-sm">
                                        <Heart className={`w-3.5 h-3.5 ${wishlist[idx] ? 'fill-emerald-600 text-emerald-600' : 'text-stone-500'}`} />
                                    </button>
                                    <button className="absolute bottom-2 right-2 w-8 h-8 bg-emerald-700 rounded-full flex items-center justify-center shadow-md sm:hidden">
                                        <Plus className="w-4 h-4 text-white" />
                                    </button>
                                </div>
                                <p className="text-[9px] sm:text-[10px] text-emerald-600 tracking-wider mb-0.5">{product.color.toUpperCase()}</p>
                                <h3 className="text-xs sm:text-sm text-stone-800 mb-0.5 leading-tight">{product.name}</h3>
                                <p className="text-xs sm:text-sm text-stone-600">{'\u20B9'}{product.price.toLocaleString()}</p>
                            </div>
                        ))}
                    </div>
                    <div className="text-center mt-6 px-5">
                        <button onClick={() => navigate('/template20/shop')} className="text-sm text-emerald-700 tracking-wider border-b border-emerald-500 pb-1 min-h-[44px] inline-flex items-center">View All Products</button>
                    </div>
                </div>
            </section>

            {/* Desktop Products Grid - EXACT original */}
            <section className="hidden lg:block py-24">
                <div className="max-w-screen-2xl mx-auto px-4 lg:px-8">
                    <div className="flex items-end justify-between gap-6 mb-10">
                        <div>
                            <p className="text-slate-500 text-sm tracking-wider mb-2">TRENDING</p>
                            <h2 className="text-4xl font-black text-slate-900">Bestsellers</h2>
                        </div>

                        {/* Brand Filter */}
                        <div className="flex items-center gap-2 flex-wrap">
                            {brands.map(brand => (
                                <button
                                    key={brand.id}
                                    onClick={() => setActiveBrand(brand.id)}
                                    className={`px-4 py-2 text-sm font-medium rounded-full transition-all ${
                                        activeBrand === brand.id
                                            ? 'bg-slate-900 text-white'
                                            : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
                                    }`}
                                >
                                    {brand.name}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="grid grid-cols-4 gap-6">
                        {desktopProducts.map((product, idx) => (
                            <div
                                key={idx}
                                className="group bg-white border border-slate-100 hover:border-slate-200 hover:shadow-lg transition-all duration-300"
                                onMouseEnter={() => setHoveredProduct(idx)}
                                onMouseLeave={() => setHoveredProduct(null)}
                            >
                                <div className="relative aspect-[3/4] overflow-hidden bg-slate-50">
                                    <img
                                        src={hoveredProduct === idx ? product.hoverImage : product.image}
                                        alt={product.name}
                                        className="w-full h-full object-cover transition-all duration-500"
                                    />
                                    {product.tag && (
                                        <span className={`absolute top-3 left-3 text-white text-[10px] font-bold tracking-wider px-2 py-1 ${
                                            product.tag === 'Bestseller' ? 'bg-green-600' :
                                            product.tag === 'Sale' ? 'bg-red-600' :
                                            product.tag === 'New' ? 'bg-blue-600' :
                                            'bg-purple-600'
                                        }`}>{product.tag.toUpperCase()}</span>
                                    )}
                                    <button className="absolute top-3 right-3 w-8 h-8 bg-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 shadow-sm">
                                        <Heart className="w-4 h-4 text-slate-600" />
                                    </button>
                                    <button className="absolute bottom-3 left-3 right-3 py-3 bg-slate-900 text-white text-xs font-bold tracking-wider opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-300 flex items-center justify-center gap-2">
                                        <Plus className="w-4 h-4" /> ADD TO BAG
                                    </button>
                                </div>
                                <div className="p-4">
                                    <div className="flex items-center justify-between mb-1">
                                        <span className="text-xs font-semibold text-blue-600">{product.brand}</span>
                                        <div className="flex items-center gap-1">
                                            <Star className="w-3 h-3 fill-yellow-400 text-yellow-400" />
                                            <span className="text-xs text-slate-600">{product.rating}</span>
                                        </div>
                                    </div>
                                    <h3 className="text-sm font-medium text-slate-800 mb-2">{product.name}</h3>
                                    <div className="flex items-center gap-2">
                                        <span className="text-base font-bold text-slate-900">₹{product.price.toLocaleString()}</span>
                                        <span className="text-sm text-slate-400 line-through">₹{product.originalPrice.toLocaleString()}</span>
                                        <span className="text-xs text-green-600 font-medium">{Math.round((1 - product.price/product.originalPrice) * 100)}% off</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="text-center mt-12">
                        <button
                            onClick={() => navigate('/template20/shop')}
                            className="group px-8 py-4 bg-slate-900 text-white font-bold tracking-wide hover:bg-slate-800 transition-colors inline-flex items-center gap-2"
                        >
                            VIEW ALL PRODUCTS <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                        </button>
                    </div>
                </div>
            </section>

            {/* ==================== BRAND STORY (mobile) ==================== */}
            <section className="lg:hidden py-10 sm:py-16">
                <div>
                    <img src="https://images.unsplash.com/photo-1490481651871-ab68de25d43d?w=1920&q=80" alt="Our Journey" className="w-full aspect-[4/5] object-cover" />
                    <div className="px-5 py-8 bg-emerald-50">
                        <div className="flex items-center gap-2 mb-3">
                            <Leaf className="w-4 h-4 text-emerald-600" />
                            <p className="text-emerald-600 text-[10px] tracking-[0.3em]">OUR PROMISE</p>
                        </div>
                        <h2 className="text-xl font-light text-stone-900 mb-4 leading-relaxed tracking-wide">Rooted in Nature, Designed for You</h2>
                        <p className="text-[14px] text-stone-600 leading-relaxed mb-4">Bloom began in a small village in Tamil Nadu, where organic cotton farmers and traditional weavers came together with a shared vision: fashion that gives back more than it takes.</p>
                        <p className="text-[14px] text-stone-600 leading-relaxed mb-6">Every garment uses natural dyes from plants, zero synthetic chemicals, and supports fair wages for every artisan in our supply chain.</p>
                        <button className="text-sm text-emerald-700 tracking-[0.15em] border-b border-emerald-700 pb-1 min-h-[44px] inline-flex items-center">OUR SUSTAINABILITY REPORT</button>
                    </div>
                </div>
            </section>

            {/* ==================== TRUST BANNER (desktop only) ==================== */}
            <section className="hidden lg:block bg-slate-900 py-12">
                <div className="max-w-screen-xl mx-auto px-4 lg:px-8 text-center">
                    <Grid3X3 className="w-10 h-10 text-blue-400 mx-auto mb-4" />
                    <h2 className="text-3xl font-black text-white mb-4">
                        100% Authentic Products
                    </h2>
                    <p className="text-slate-400 max-w-xl mx-auto">
                        Every product on Supreme is sourced directly from authorized brand partners. Shop with confidence.
                    </p>
                </div>
            </section>

            {/* ==================== TESTIMONIALS / REVIEWS ==================== */}
            {/* Mobile Testimonials - swipeable */}
            <section className="lg:hidden py-10 sm:py-16 bg-emerald-800">
                <div className="max-w-screen-xl mx-auto px-5 sm:px-6">
                    <div className="text-center mb-8">
                        <p className="text-emerald-300 text-[10px] sm:text-xs tracking-[0.3em] mb-2">COMMUNITY VOICES</p>
                        <h2 className="text-xl sm:text-2xl font-light text-white tracking-wide">Stories from Our Community</h2>
                    </div>
                    <div className="overflow-hidden" onTouchStart={e => handleTestimonialSwipe(e, 'start')} onTouchEnd={e => handleTestimonialSwipe(e, 'end')}>
                        <div className="flex transition-transform duration-500 ease-out" style={{ transform: `translateX(-${activeTestimonial * 100}%)` }}>
                            {mobileTestimonials.map((t, idx) => (
                                <div key={idx} className="w-full flex-shrink-0 px-2">
                                    <div className="text-center">
                                        <div className="flex justify-center gap-1 mb-4">{[...Array(t.rating)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-emerald-300 text-emerald-300" />)}</div>
                                        <p className="text-[14px] text-emerald-100 leading-relaxed mb-5 italic font-light">"{t.text}"</p>
                                        <p className="text-white text-sm">{t.name}</p>
                                        <p className="text-emerald-400 text-xs mt-1">{t.city}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="flex justify-center gap-2 mt-6">
                            {mobileTestimonials.map((_, idx) => (
                                <button key={idx} onClick={() => setActiveTestimonial(idx)} className={`w-2 h-2 rounded-full transition-all ${activeTestimonial === idx ? 'bg-emerald-300 w-6' : 'bg-emerald-600'}`} />
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            {/* Desktop Reviews - EXACT original */}
            <section className="hidden lg:block py-24 bg-slate-50">
                <div className="max-w-screen-xl mx-auto px-4 lg:px-8">
                    <div className="text-center mb-12">
                        <p className="text-slate-500 text-sm tracking-wider mb-2">REVIEWS</p>
                        <h2 className="text-4xl font-black text-slate-900">What Our Customers Say</h2>
                    </div>

                    <div className="grid grid-cols-3 gap-6">
                        {desktopReviews.map((review, idx) => (
                            <div key={idx} className="bg-white p-6 shadow-sm">
                                <div className="flex gap-1 mb-4">
                                    {[...Array(review.rating)].map((_, i) => (
                                        <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                                    ))}
                                </div>
                                <p className="text-slate-700 mb-4 leading-relaxed">"{review.text}"</p>
                                <div className="flex items-center gap-3 pt-4 border-t border-slate-100">
                                    <div className="w-10 h-10 bg-slate-200 rounded-full flex items-center justify-center">
                                        <span className="text-slate-700 font-bold">{review.name.charAt(0)}</span>
                                    </div>
                                    <div>
                                        <p className="font-bold text-slate-800 text-sm">{review.name}</p>
                                        <p className="text-slate-500 text-xs">{review.city}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ==================== INSTAGRAM (mobile only) ==================== */}
            <section className="lg:hidden py-10 sm:py-16">
                <div className="max-w-screen-2xl mx-auto px-5 sm:px-6">
                    <div className="text-center mb-6">
                        <div className="flex items-center justify-center gap-2 mb-2">
                            <Instagram className="w-4 h-4 text-emerald-600" />
                            <span className="text-xs text-stone-500 tracking-[0.2em]">@bloom.earth</span>
                        </div>
                        <h2 className="text-xl sm:text-2xl font-light text-stone-900 tracking-wide">From Our Garden</h2>
                    </div>
                    <div className="grid grid-cols-3 gap-1 sm:gap-1.5">
                        {instagramPosts.map((post, idx) => (
                            <div key={idx} className="aspect-square group cursor-pointer overflow-hidden rounded-lg">
                                <img src={post} alt={`Bloom ${idx + 1}`} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ==================== NEWSLETTER ==================== */}
            {/* Mobile Newsletter */}
            <section className="lg:hidden py-10 sm:py-16 bg-emerald-50">
                <div className="max-w-xl mx-auto px-5 sm:px-6 text-center">
                    <Leaf className="w-8 h-8 text-emerald-600 mx-auto mb-4" strokeWidth={1.5} />
                    <h2 className="text-xl sm:text-2xl font-light text-stone-900 mb-3 tracking-wide">Join the Bloom Community</h2>
                    <p className="text-stone-500 text-[14px] sm:text-sm mb-6 sm:mb-8">Receive updates on new collections, sustainability insights, and an exclusive 10% welcome gift.</p>
                    <div className="flex flex-col sm:flex-row gap-3">
                        <input type="email" placeholder="Your email address" className="flex-1 px-5 py-4 bg-white border border-stone-200 text-stone-800 text-sm placeholder-stone-400 focus:outline-none focus:ring-1 focus:ring-emerald-500 focus:border-emerald-500 rounded-full sm:rounded-lg min-h-[48px]" />
                        <button className="px-8 py-4 bg-emerald-700 text-white text-xs tracking-[0.2em] hover:bg-emerald-600 transition-colors w-full sm:w-auto rounded-full sm:rounded-lg min-h-[48px]">JOIN</button>
                    </div>
                    <p className="text-stone-400 text-xs mt-4">We plant a tree for every subscriber.</p>
                </div>
            </section>

            {/* Desktop Newsletter - EXACT original */}
            <section className="hidden lg:block py-20 bg-white">
                <div className="max-w-xl mx-auto px-4 text-center">
                    <h2 className="text-3xl font-black text-slate-900 mb-4">Join the Club</h2>
                    <p className="text-slate-600 mb-8">
                        Subscribe for exclusive deals, new arrivals, and insider access to sales.
                    </p>
                    <div className="flex gap-3">
                        <input
                            type="email"
                            placeholder="Enter your email"
                            className="flex-1 px-5 py-4 bg-slate-100 border-0 text-slate-900 text-sm placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-slate-300"
                        />
                        <button className="px-8 py-4 bg-slate-900 text-white text-sm font-bold tracking-wide hover:bg-slate-800 transition-colors">
                            SUBSCRIBE
                        </button>
                    </div>
                </div>
            </section>

            {/* ==================== FOOTER ==================== */}
            {/* Mobile Footer */}
            <footer className="lg:hidden bg-stone-100 border-t border-stone-200">
                <div className="max-w-screen-2xl mx-auto px-5 sm:px-6 py-10 sm:py-16">
                    <div className="grid grid-cols-2 gap-8">
                        <div className="col-span-2">
                            <h3 className="text-xl font-light tracking-[0.2em] mb-4 text-stone-800">BLOOM</h3>
                            <p className="text-stone-500 text-sm leading-relaxed">Sustainable fashion for a better tomorrow. Organic, ethical, and made with love in India.</p>
                        </div>
                        <div>
                            <h4 className="text-[10px] tracking-[0.2em] mb-4 text-stone-400">SHOP</h4>
                            <ul className="space-y-2 text-sm">
                                <li><span onClick={() => navigate('/template20/shop')} className="text-stone-600 hover:text-emerald-700 cursor-pointer transition-colors min-h-[44px] inline-flex items-center">All Products</span></li>
                                <li><span className="text-stone-600 hover:text-emerald-700 cursor-pointer transition-colors min-h-[44px] inline-flex items-center">New Arrivals</span></li>
                                <li><span className="text-stone-600 hover:text-emerald-700 cursor-pointer transition-colors min-h-[44px] inline-flex items-center">Bestsellers</span></li>
                            </ul>
                        </div>
                        <div>
                            <h4 className="text-[10px] tracking-[0.2em] mb-4 text-stone-400">HELP</h4>
                            <ul className="space-y-2 text-sm">
                                <li><span onClick={() => navigate('/template20/contact')} className="text-stone-600 hover:text-emerald-700 cursor-pointer transition-colors min-h-[44px] inline-flex items-center">Contact</span></li>
                                <li><span onClick={() => navigate('/template20/orders')} className="text-stone-600 hover:text-emerald-700 cursor-pointer transition-colors min-h-[44px] inline-flex items-center">Track Order</span></li>
                                <li><span className="text-stone-600 hover:text-emerald-700 cursor-pointer transition-colors min-h-[44px] inline-flex items-center">Returns</span></li>
                            </ul>
                        </div>
                        <div>
                            <h4 className="text-[10px] tracking-[0.2em] mb-4 text-stone-400">CONNECT</h4>
                            <ul className="space-y-2 text-sm">
                                <li className="text-stone-600">hello@bloom.earth</li>
                                <li className="text-stone-600">+91 98765 43210</li>
                                <li className="text-stone-600 pt-1">Mon - Sat: 10am - 6pm</li>
                            </ul>
                        </div>
                    </div>
                    <div className="border-t border-stone-200 mt-8 pt-6 flex flex-col items-center gap-4">
                        <p className="text-stone-400 text-xs">&copy; 2025 Bloom. All rights reserved.</p>
                        <div className="flex gap-6 text-xs text-stone-400">
                            <span className="hover:text-emerald-700 cursor-pointer transition-colors min-h-[44px] inline-flex items-center">Privacy</span>
                            <span className="hover:text-emerald-700 cursor-pointer transition-colors min-h-[44px] inline-flex items-center">Terms</span>
                        </div>
                    </div>
                </div>
            </footer>

            {/* Desktop Footer - EXACT original */}
            <footer className="hidden lg:block bg-slate-900 text-white">
                <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 py-16">
                    <div className="grid grid-cols-4 gap-12">
                        <div>
                            <h3 className="text-2xl font-black mb-4">SUPREME</h3>
                            <p className="text-slate-400 text-sm leading-relaxed">
                                India's premium multi-brand fashion destination. 50+ brands, 10,000+ products.
                            </p>
                        </div>

                        <div>
                            <h4 className="text-xs font-bold tracking-wider mb-4 text-slate-300">SHOP</h4>
                            <ul className="space-y-2 text-sm">
                                <li><span onClick={() => navigate('/template20/shop')} className="text-slate-400 hover:text-white cursor-pointer transition-colors">All Products</span></li>
                                <li><span className="text-slate-400 hover:text-white cursor-pointer transition-colors">Women</span></li>
                                <li><span className="text-slate-400 hover:text-white cursor-pointer transition-colors">Men</span></li>
                                <li><span className="text-slate-400 hover:text-white cursor-pointer transition-colors">Kids</span></li>
                            </ul>
                        </div>

                        <div>
                            <h4 className="text-xs font-bold tracking-wider mb-4 text-slate-300">HELP</h4>
                            <ul className="space-y-2 text-sm">
                                <li><span onClick={() => navigate('/template20/contact')} className="text-slate-400 hover:text-white cursor-pointer transition-colors">Contact</span></li>
                                <li><span onClick={() => navigate('/template20/orders')} className="text-slate-400 hover:text-white cursor-pointer transition-colors">Track Order</span></li>
                                <li><span className="text-slate-400 hover:text-white cursor-pointer transition-colors">Returns</span></li>
                                <li><span className="text-slate-400 hover:text-white cursor-pointer transition-colors">FAQ</span></li>
                            </ul>
                        </div>

                        <div>
                            <h4 className="text-xs font-bold tracking-wider mb-4 text-slate-300">CONNECT</h4>
                            <ul className="space-y-2 text-sm">
                                <li className="text-slate-400">support@supreme.in</li>
                                <li className="text-slate-400">1800-123-4567</li>
                                <li className="text-slate-400 pt-2">Mon - Sun: 9am - 9pm</li>
                            </ul>
                        </div>
                    </div>

                    <div className="border-t border-slate-800 mt-12 pt-8 flex justify-between items-center gap-4">
                        <p className="text-slate-500 text-xs">© 2025 Supreme. All rights reserved.</p>
                        <div className="flex gap-6 text-xs text-slate-500">
                            <span className="hover:text-white cursor-pointer transition-colors">Privacy</span>
                            <span className="hover:text-white cursor-pointer transition-colors">Terms</span>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Template20;